import { render, staticRenderFns } from "./Popper.vue?vue&type=template&id=25ee6d49&scoped=true&"
import script from "./Popper.vue?vue&type=script&lang=ts&"
export * from "./Popper.vue?vue&type=script&lang=ts&"
import style0 from "./Popper.vue?vue&type=style&index=0&id=25ee6d49&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25ee6d49",
  null
  
)

export default component.exports